export const OPEN_SPECIAL_RATE_ADDITION_MODAL = 'OPEN_SPECIAL_RATE_ADDITION_MODAL';
export const CLOSE_SPECIAL_RATE_ADDITION_MODAL = 'CLOSE_SPECIAL_RATE_ADDITION_MODAL';

function show() {
  return {
    type: OPEN_SPECIAL_RATE_ADDITION_MODAL,
    isSpecialRatesModalShown: true
  };
}

export function hide() {
  return {
    type: CLOSE_SPECIAL_RATE_ADDITION_MODAL,
    isSpecialRatesModalShown: false
  };
}

export function showSpecialRateAdditionModal() {
  return dispatch => dispatch(show());
}

export function hideSpecialRateAdditionModal() {
  return dispatch => dispatch(hide());
}
